import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

interface HeroFRCProps {
    jumpLinkHandler(): void;
}

export const HeroFRC = ({jumpLinkHandler}: HeroFRCProps) => {
    const {gettext} = useI18n();

    return (
        <div data-purpose="hero-frc" className="section--hero">
            <div className="section-content">
                <h1 className="ud-heading-serif-xxl section-title--hero" data-purpose="hero-title">
                    {gettext('Free online courses to achieve your goals')}
                </h1>
                <p className="ud-text-md section-text--hero">
                    {gettext(
                        'Looking to add new skills? Is there a hobby you’ve wanted to try? ' +
                            'We’re Udemy, a leading destination for learning and teaching online.',
                    )}
                </p>
                <p className="ud-text-md section-text--hero">
                    {gettext(
                        'If you’re new to online learning and not sure where to start, ' +
                            'you’re not alone. We’ve curated a free collection of courses for ' +
                            'professionals. Take one of these courses and learn new skills (on us).',
                    )}
                </p>
                <Button
                    className="section-cta--hero"
                    onClick={jumpLinkHandler}
                    data-purpose="browse-courses-cta"
                >
                    {gettext('Take free courses')}
                </Button>
            </div>
        </div>
    );
};
